import { iotRequest } from './iot_http';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;
const PATH = '/api/iot/gate';

// The per-esercizio switch of the IoT gate cutover (ADR-0014, BSDEVPLAT-99
// server-side, BSDEVPLAT-119 here). One boolean, `iot_gate_attivo`, governs the
// four effects of the new gate together: the value written on the Registrazione
// (media instead of lettura puntuale), notifiche, escalation and digest.
//
// Not to be confused with the `iot` module chip of the app: that one shows the
// IoT section in the app, this one decides which path notifies the clienti of
// the esercizio.
//
// Who flipped and when is the server's audit trail (`IOT_GATE_ATTIVO_FLIP`), not
// something the panel sends along.

/** The state of the switch with its four effects, as the server reads it. */
export const getStatoInterruttoreGate = (esercizioId) =>
  iotRequest(
    `${BASE_URL}${PATH}?esercizioId=${encodeURIComponent(esercizioId)}`,
    'GET',
  );

/**
 * Brings the switch to `attivo`. The value travels in the body on purpose:
 * there is no bodiless toggle, so two admins pressing the button together
 * cannot leave the switch where neither wanted it. Idempotent: asking for the
 * state already on the row answers 200 with that state.
 */
export const flipInterruttoreGate = (esercizioId, attivo) =>
  iotRequest(`${BASE_URL}${PATH}/${encodeURIComponent(esercizioId)}`, 'PUT', {
    attivo,
  });
